export default [
  {
    path: '/dashboard/cylinder/orders',
    name: 'CylinderOrdersList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Cylinder/OrderListView.vue')
  },
  {
    path: '/dashboard/cylinder/:id/edit',
    name: 'CylinderOrderEdit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Cylinder/OrderEditView.vue')
  },
  {
    path: '/dashboard/cylinder/specials',
    name: 'CylinderSpecialsList',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Cylinder/Specials/SpecialListView.vue')
  },
  {
    path: '/dashboard/cylinder/specials/create',
    name: 'CylinderSpecialsCreate',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Cylinder/Specials/SpecialCreateView.vue')
  },
  {
    path: '/dashboard/cylinder/specials/:id/edit',
    name: 'CylinderSpecialsEdit',
    meta: { layout: 'dashboard-layout' },
    component: () => import('../../views/Cylinder/Specials/SpecialEditView.vue')
  }
]
